/**
 * Detects if Global Privacy Control (GPC) is enabled in the browser.
 * GPC is a privacy signal that indicates the user's preference to opt-out
 * of data sales and sharing.
 *
 * @returns true if navigator.globalPrivacyControl is enabled, false otherwise
 */
export function isGpcEnabled(): boolean {
  if (typeof navigator === "undefined") return false;
  return (navigator as any).globalPrivacyControl === true;
}
